registerComponent("sections/quem-somos", function (component) {
/**
 * 1. A entrada na rolagem (ADR 0051): as peças marcadas `.entrada` no HTML
 *    entram quando a seção chega na tela — numa linha escalonada no desktop,
 *    uma a uma abaixo do degrau. Ver `Asa.armarEntrada` em asa.js.
 * 2. Na variante de "Sobre o ASA" e SÓ no celular, os quatro cartões viram um
 *    trilho horizontal com encaixe (10805:73871) e os indicadores abaixo
 *    seguem o cartão que está no centro (10805:73855).
 *
 * @param {HTMLElement} component - elemento raiz do componente
 * @param {Object} params
 */

Asa.armarEntrada([component], '.entrada');

/* ══════════════════════════════════════════ os indicadores do trilho ══════
   Só existem na variante de "Sobre o ASA" — na home os quatro cartões
   empilham e não há trilho. O estado é lido da POSIÇÃO do trilho, não de um
   índice guardado: assim o dedo, a barra de rolagem e um `scrollIntoView`
   caem todos no mesmo caminho.

   O trilho é `overflow-x: auto` só abaixo de 768 (ver `_quem-somos.less`);
   acima disso ele não rola e o `scroll` nunca dispara, então não há o que
   desligar no degrau. */
const trilho = component.querySelector('.quem__valores');
const indicadores = [...component.querySelectorAll('.quem__indicador')];

if (trilho && indicadores.length) {
    const cartoes = [...trilho.querySelectorAll('.valor')];

    // O cartão cujo CENTRO está mais perto do centro do trilho. É o critério
    // que casa com `scroll-snap-align: center`.
    const atual = () => {
        const meio = trilho.scrollLeft + trilho.clientWidth / 2;
        let melhor = 0;
        let menor = Infinity;
        cartoes.forEach((cartao, i) => {
            const centro = cartao.offsetLeft + cartao.offsetWidth / 2;
            const dist = Math.abs(centro - meio);
            if (dist < menor) { menor = dist; melhor = i; }
        });
        return melhor;
    };

    let ultimo = -1;
    const marcar = () => {
        const i = atual();
        if (i === ultimo) return;
        ultimo = i;
        indicadores.forEach((ind, j) => {
            ind.classList.toggle('quem__indicador--ativo', j === i);
        });
    };

    // Um `requestAnimationFrame` por rajada de `scroll`, como o resto do
    // projeto (ver a disciplina de rolagem em code-quality.md).
    let agendado = false;
    trilho.addEventListener('scroll', () => {
        if (agendado) return;
        agendado = true;
        requestAnimationFrame(() => { agendado = false; marcar(); });
    }, { passive: true });

    marcar();
}

});
